import { render, staticRenderFns } from "./BackspaceIcon.vue?vue&type=template&id=18c689b8&"
import script from "./BackspaceIcon.vue?vue&type=script&lang=js&"
export * from "./BackspaceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports